import "./CMS.scss";

export interface CMSPlaceholderAPI {
  readonly getElement: () => HTMLElement;
  readonly setVisible: (visible: boolean) => void;
  readonly destroy: () => void;
}

export const createCMSPlaceholder = (): CMSPlaceholderAPI => {
  const container = document.createElement("div");
  container.className = "dedicated-placeholder dedicated-placeholder--cms";

  container.innerHTML = `
    <div class="dedicated-placeholder__header">
      <h2 class="dedicated-placeholder__title">Content Management System</h2>
      <p class="dedicated-placeholder__subtitle">
        Manage data sources, media libraries, and localized content. Coming soon.
      </p>
    </div>
    <div class="dedicated-placeholder__body">
      <div class="dedicated-placeholder__panel">
        <p class="dedicated-placeholder__text">
          The CMS view will surface connected articles, media assets, and translation workflows.
        </p>
        <p class="dedicated-placeholder__text">
          Placeholder content keeps the experience coherent while implementation is underway.
        </p>
      </div>
    </div>
  `;

  const setVisible = (visible: boolean) => {
    container.style.display = visible ? "flex" : "none";
  };

  const destroy = () => {
    container.remove();
  };

  return {
    getElement: () => container,
    setVisible,
    destroy,
  };
};
